import logoSrc from '../../assets/azoya_logo_vaux.svg'
import logoDarkSrc from '../../assets/azoya_logo_vaux_dark.svg'

export type LogoTone = 'default' | 'dark'

export interface LogoProps {
  size?: number
  opacity?: number
  tone?: LogoTone
}

const SOURCES: Record<LogoTone, string> = {
  default: logoSrc,
  dark: logoDarkSrc,
}

/**
 * Azoya Spa brand mark. `tone="default"` is the transparent blue mark
 * (fill matches `color-primary`) for light backgrounds; `tone="dark"` is
 * the transparent orange typographic badge (icon + wordmark) for dark
 * backgrounds — no background of its own (fixed in Cycle 12: an earlier
 * version baked in an opaque `color-primary` rect, which blended on a flat
 * footer but clipped a visible square hole through any textured/patterned
 * dark background, e.g. `FooterBand`'s watermark). Truly transparent now,
 * so it composes over any dark surface, textured or not.
 * No `rotate`/`transform` prop exists by design: the brand guideline
 * (charte_graphique/Charte-graphique-azoya-spa.pdf, "À ne pas faire")
 * forbids tilting or recomposing the logo. Placement (protection zone,
 * bleed) is the caller's responsibility via layout/overflow.
 */
export function Logo({ size = 120, opacity = 1, tone = 'default' }: LogoProps) {
  return (
    <img
      src={SOURCES[tone]}
      alt=""
      aria-hidden="true"
      width={size}
      style={{ opacity, height: 'auto' }}
    />
  )
}
